/**
 * @Date:   2018-01-22T13:12:39+08:00
 * @Last modified time: 2018-02-24T10:32:05+08:00
 */
 import React from 'react';
 import { Link } from 'react-router-dom';
 import DocumentTitle from 'react-document-title';
 // import { connect } from 'react-redux';
 // import { Icon } from 'antd';
 import GlobalFooter from '../components/GlobalFooter';
 // import logo from '../logo.jpg';
 import logo from '../logo.png';
 import './UserLayout.less';
 // import { getRoutes } from '../utils/utils';

 const links = [{
   title: '帮助',
   href: '',
   key: "link_help"
 }, {
   title: '隐私',
   href: '',
   key:"link_privacy"
 }, {
   title: '条款',
   href: '',
   key:"link_caluse"
 }];
 const thisYear = (new Date()).getFullYear();
const copyright = <div>Copyright &copy; {thisYear} Egiraffe All Right Reserved.</div>;

 let UserLayoutWrapper = (WrappedComponent) => {
     class UserLayout extends React.PureComponent {
         // getPageTitle() {
         //     const { routerData, location } = this.props;
         //     const { pathname } = location;
         //     let title = 'Ant Design Pro';
         //     if (routerData[pathname] && routerData[pathname].name) {
         //         title = `${routerData[pathname].name} - Ant Design Pro`;
         //     }
         //     return title;
         // }
         render() {
             // const { routerData, match } = this.props; links={links}
             return (
                 <DocumentTitle title="长颈鹿美语 | 登陆">
                     <div className="container">
                         <div className="top">
                             <div>
                                 <Link to="/">
                                 <img alt="logo" src={logo} style={{width: "200px"}} />
                             </Link>
                         </div>
                     </div>
                     <WrappedComponent />
                     <GlobalFooter className="footer"  copyright={copyright} />
                 </div>
             </DocumentTitle>
            );
         }
     }
    return UserLayout;
 }

 // const mapStateToProps = (state) => {
 //     return {
 //       userInfo: state.user.userInfo
 //     }
 // };
 // const mapDispatchToProps = {};
 //
 // UserLayoutWrapper = connect(mapStateToProps, mapDispatchToProps)(UserLayoutWrapper);
 export default UserLayoutWrapper;



// WEBPACK FOOTER //
// ./src/layouts/UserLayoutWrapper.js